import { Actions } from "../../components/buttons/Actions";
import { actionsColumn, createdColumn } from "../../constants/objects";
import { APP_NAME } from "../../constants/webapp";
import { dateTimeFormat } from "../../utils/formatter";
import { DeleteData } from "../firebase/useFirebase";
import { DescWrapper } from "../useProducts";

export const useNotifications = () => {
  const tableData = (data) => [
    ...data.map((item) => {
      const row = {
        timestamp: dateTimeFormat(item?.timestamp),
        notification: (
          <div>
            <p>{item?.title || APP_NAME}</p>
            <DescWrapper className="font11 thin lightColor">
              {item?.body}
            </DescWrapper>
          </div>
        ),

        actions: (
          <Actions
            actions={[
              {
                action: "Delete",
                click: () => DeleteData(item.docRef),
                confirm: true,
              },
            ]}
          />
        ),
      };
      return row;
    }),
  ];

  const tableColumns = [
    { id: "notification", title: "Notification", align: "left" },
    createdColumn,
    actionsColumn,
  ];

  return { tableColumns, tableData };
};
